import axios from "axios";
import { getToken } from "../../../Utlis/UpdateUserState";

const getAdminFuelTypes = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-types/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel types fetch error:", error);
    throw error;
  }
};

const getAdminFuelTypeById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-types/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel type fetch error:", error);
    throw error;
  }
};

const createFuelType = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-types/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel type create error:", error);
    throw error;
  }
};

const updateFuelType = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-types/?id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel type update error:", error);
    throw error;
  }
};

const deleteFuelType = async (id) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-types/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel type delete error:", error);
    throw error;
  }
};

export {
  getAdminFuelTypes,
  getAdminFuelTypeById,
  createFuelType,
  updateFuelType,
  deleteFuelType,
};
